import { useRef } from 'react'
import type { RecentSearchesStatus } from 'hooks/Flights/useRecentFlightSearches'
import { RECENT_SEARCHES_STATUS } from 'hooks/Flights/useRecentFlightSearches'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import RecentFlightSearch from 'components/Flights/RecentFlightSearch/RecentFlightSearch'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import styled from 'styled-components'

interface RecentFlightSearchesCarouselProps {
  recentSearches: Array<App.RecentFlightSearch> | undefined
  status: RecentSearchesStatus
}

const StyledLoadingIndicator = styled(LoadingIndicator)`
  padding: 0;
`

function RecentFlightSearchesCarousel({ recentSearches, status }: RecentFlightSearchesCarouselProps) {
  const carouselRef = useRef<HTMLDivElement | null>(null)

  if (status === RECENT_SEARCHES_STATUS.ERROR) {
    return null
  }

  return (
    <>
      {status === RECENT_SEARCHES_STATUS.FETCHING && <StyledLoadingIndicator inline ballSize={12} />}
      {status === RECENT_SEARCHES_STATUS.AVAILABLE && recentSearches && recentSearches.length > 0 && <CardCarousel
        snap="center"
        pageSize={3}
        ref={carouselRef}
        gap={20}
      >
        {status === RECENT_SEARCHES_STATUS.AVAILABLE && recentSearches && recentSearches.length > 0 && recentSearches.map((search, index) => (
          <RecentFlightSearch key={index} recentSearch={search} />
        ))}
      </CardCarousel>}
    </>
  )
}

export default RecentFlightSearchesCarousel
